import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  host: { 'class': 'w-full block' }
})
export class SignInComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  loginForm = new FormGroup({
    username: new FormControl('', { validators: [Validators.required], nonNullable: true }),
    password: new FormControl('', { validators: [Validators.required], nonNullable: true }),
    rememberMe: new FormControl(false, { nonNullable: true })
  });

  isLoading = false;
  errorMessage = '';
  passwordVisible = false;

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      const { username, password } = this.loginForm.value;
      const normalizedUsername = username!.toLowerCase();
      
      this.authService.login({ username: normalizedUsername, password: password! }).subscribe({
        next: () => {
          this.router.navigate(['/']); // Redirect to home on success
        },
        error: (err: HttpErrorResponse) => {
          this.isLoading = false;
          
          if (err.error?.detail === 'account_not_activated') {
            // Redirect to check-email if account exists but is not activated
            this.router.navigate(['/auth/check-email'], {
              queryParams: { type: 'signup', email: err.error.email }
            });
          } else {
            this.errorMessage = err.error?.detail || 'Failed to login. Please check your credentials.';
          }
        }
      });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
